/**
 * The MCP content cluster beyond the hub and client guides: pages that target
 * the queries the product pages never will (comparisons, lists, definitions).
 * One registry so cross-linking, heads and further-reading rows stay in sync.
 */
export type McpArticle = {
  slug: string;
  /** Breadcrumb label, kept short for the crumb trail. */
  name: string;
  /** Anchor text for internal links: matches the target page's h1. */
  linkTitle: string;
  metaTitle: string;
  metaDescription: string;
  /** One line under the link in further-reading rows. */
  teaser: string;
};

export const MCP_ARTICLES: McpArticle[] = [
  {
    slug: "flowstep-vs-figma-mcp",
    name: "Flowstep vs Figma MCP",
    linkTitle: "Flowstep MCP vs Figma MCP",
    metaTitle: "Flowstep MCP vs Figma MCP Server: What's the Difference?",
    metaDescription:
      "How Flowstep's MCP server compares to Figma's: generating new UI versus working from existing designs, where the output lives, and why teams run both.",
    teaser:
      "Two design-tool MCP servers, two different jobs — and why running both works.",
  },
  {
    slug: "best-mcp-servers-for-designers",
    name: "Best MCP servers",
    linkTitle: "The best MCP servers for design work",
    metaTitle: "8 Best MCP Servers for Designers and Design Engineers",
    metaDescription:
      "The MCP servers worth connecting for design work: generating UI, reading design files, checking the rendered result, and keeping specs in the loop.",
    teaser:
      "The servers worth connecting when your agent's job involves an interface.",
  },
  {
    slug: "what-is-mcp-for-designers",
    name: "What is MCP?",
    linkTitle: "What is MCP? A designer's guide",
    metaTitle: "What Is MCP? A Designer's Guide to Model Context Protocol",
    metaDescription:
      "The Model Context Protocol explained without the plumbing: what MCP servers and clients are, and what they change about how interfaces get designed.",
    teaser:
      "The protocol behind agent tooling, explained without the plumbing.",
  },
];

export const mcpArticlePath = (slug: string) => `/mcp/${slug}`;
